<template lang="pug">
div.tw-flex.tw-flex-row.tw-gap-8.tw-flex-wrap.tw-px-1(
	class="emd:tw-gap-4 emd:tw-max-w-full"
	:class="bookingStore.isRoundTrip ? 'tw-gap-4' : 'tw-gap-8'"
	ref="stepsReference"
	)
	template(v-if="'postSale' != stepper.bookingType")
		template(v-if="'tickets' == stepper.bookingType")
			step-item(v-bind='stepItemProps["forward-search"]')
			step-item(v-bind='stepItemProps["forward-travel-solutions"]')
			step-item(v-if='stepper.seatSelectionStepEnabled' v-bind='stepItemProps["forward-seat-selection"]')
			step-item(v-if="bookingStore.isRoundTrip" v-bind='stepItemProps["return-travel-solutions"]')
			step-item(v-if='bookingStore.isRoundTrip && stepper.returnSeatSelectionStepEnabled' v-bind='stepItemProps["return-seat-selection"]')
			step-item(v-bind='stepItemProps["travellers"]')
		template(v-else-if="'carnet' == stepper.bookingType")
			step-item(v-bind='stepItemProps["search"]')
			step-item(v-bind='stepItemProps["carnet-solutions"]')
			step-item(v-bind='stepItemProps["buyer-data"]')
			//step-item(number='2' :label='$t("sale.stepper.choose_carnet", "Scelta Carnet")' :is-active="stepper.step == 'carnet-solutions'" @click="changeStep('carnet-solutions')")
			//step-item(number='3' :label='$t("sale.stepper.payment_data", "Dati Pagamento")' :is-active="stepper.step == 'buyer-data'")

	template(v-else-if="showPostSaleStepper")
		template(v-if="postSale.isForwardReturnFlow || stepper.inForwardPages")
			step-item(v-if="dontExcludePostSaleStep" v-bind='stepItemProps["forward-search"]')
			step-item(v-bind='stepItemProps["forward-travel-solutions"]')
			step-item(v-if='stepper.seatSelectionStepEnabled && dontExcludePostSaleStep' v-bind='stepItemProps["forward-seat-selection"]')
		template(v-if="postSale.isForwardReturnFlow || stepper.inReturnPages" )
			step-item(v-if="dontExcludePostSaleStep" v-bind='stepItemProps["return-search"]')
			step-item(v-bind='stepItemProps["return-travel-solutions"]')
			step-item(v-if='stepper.returnSeatSelectionStepEnabled && dontExcludePostSaleStep' v-bind='stepItemProps["return-seat-selection"]')
</template>

<script setup>
import {computed, ref, watch} from 'vue';
import StepItem from './step-item.vue';
import { useBookingStepperStore } from '@/stores/booking-stepper';
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import {useBookingStore} from "@/stores/booking";
import {usePostSaleStore} from "@/stores/post-sale";


const postSale = usePostSaleStore();
const stepper = useBookingStepperStore();
const i18n = useI18n();
const stepItemProps = reactive({});
const {mobileStyle} = defineProps({
	mobileStyle: {
		type: Boolean,
		default: false
	}
})
const steps = [
	{key: 'carnet-solutions', label: i18n.t('sale.stepper.choose_carnet', 'Scelta Carnet'), icon: 'mdi-magnify'},
	{key: 'search', label: i18n.t('sale.stepper.search', 'Ricerca'), icon: 'mdi-magnify'},
	{key: 'forward-search', label: i18n.t('sale.stepper.search', 'Ricerca'), icon: 'mdi-magnify'},
	{key: 'forward-travel-solutions', label: i18n.t('sale.stepper.travel_solutions', 'Scelta Viaggio'), icon: 'mdi-train'},
	{key: 'forward-seat-selection', label: i18n.t('form_labels.travel_solution.seats_choose', 'Scegli Posti'), icon: 'mdi-seat'},
	{key: 'return-search', label: i18n.t('sale.stepper.search', 'Ricerca'), icon: 'mdi-magnify'},
	{key: 'return-travel-solutions', label: i18n.t('sale.stepper.travel_solutions_return', 'Ritorno'), icon: 'mdi-train-variant'},
	{key: 'return-seat-selection', label: i18n.t('sale.stepper.seats_choose_return', 'Posti Ritorno'), icon: 'mdi-seat'},
	{key: 'travellers', label: i18n.t('common.passenger', 1), icon: 'mdi-account-multiple'},
	{key: 'buyer-data', label: i18n.t('sale.stepper.payment_data', 'Dati Pagamento'), icon: 'mdi-account-tie'},
];
const carnetSteps = [
	{
		key: 'search',
		label: i18n.t('sale.stepper.search', 'Ricerca'),
		icon: 'mdi-magnify',
	},
	{
		key: 'carnet-solutions',
		label: i18n.t("sale.stepper.choose_carnet", "Scelta Carnet"),
		icon: 'mdi-ticket-confirmation-outline'
	},
	{
		key: 'buyer-data',
		label: i18n.t("sale.stepper.payment_data", "Dati Pagamento"),
		icon: 'mdi-credit-card-outline'
	}
];
const bookingStore = useBookingStore();
const showPostSaleStepper = computed(() => {
	return ['booking_change_before_departure', 'change_class', 'travel_change_before_departure'].includes(postSale.selectedEdit);
});
const dontExcludePostSaleStep = computed(() => {
	return !['change_class'].includes(postSale.selectedEdit);
});
const stepsReference = ref();


function changeStep(newStep){
	// we can only go back from stepper
	if(!stepper.stepNumbers[newStep] || stepper.currentStepNumber < stepper.stepNumbers[newStep]) return;
	if(newStep == stepper.step) return;
	stepper.step = newStep;
	bookingStore.setEvaluatedSolution();
}
function makeStepItemProps(stepName, label, icon){
	return computed(() => {
		const clickable = stepper.currentStepNumber > stepper.stepNumbers[stepName];
		const classes = {
			'tw-cursor-pointer': clickable
		};
		return {
			class: classes,
			number: String(stepper.stepNumbers[stepName]),
			label,
			isActive: stepper.step == stepName,
			completed: stepper.stepStatus[stepName].completed,
			icon: icon,
			onClick: () => clickable && changeStep(stepName)
		};
	});
}


defineExpose({
	stepsReference
});


watch(() => stepper.bookingType, () => {
	if ('postSale' == stepper.bookingType) return;
	const stps = 'tickets' == stepper.bookingType ? steps : ('carnet' == stepper.bookingType ? carnetSteps : []);

	for (const step of stps) {
		if ('postSale' == stepper.bookingType && !stepper.rightSteps.includes(step.key)) continue;
		const icon = mobileStyle ? step.icon : null;
		stepItemProps[step.key] = makeStepItemProps(step.key, step.label, icon);
	}

});


for (const step of steps) {
	if ('postSale' == stepper.bookingType && !stepper.rightSteps.includes(step.key)) continue;
	const icon = mobileStyle ? step.icon : null;
	stepItemProps[step.key] = makeStepItemProps(step.key, step.label, icon);
}
</script>

<style scoped>
.hide {
	opacity: 0;
}
.scaleOutTop {
	animation: kScaleOutTop 1.2s ease 0s 1 normal forwards;
}
.scaleInForwardCenter {
	animation: kScaleInForwardCenter 1s ease 0s 1 normal forwards;
}

@keyframes kScaleOutTop {
	0% {
		transform: scale(1);
		transform-origin: 50% 0%;
	}

	100% {
		transform: scale(0);
		transform-origin: 50% 0%;
	}
}
@keyframes kScaleInForwardCenter {
	0% {
		transform: scale(0);
	}

	100% {
		transform: scale(1);
	}
}
</style>